<template>
  <div style="background-color: #f6f5f5">
    <template v-if="isReadInfo"> </template>
    <template v-else>
      <v-alert v-if="isReadonly" text type="warning">
        <div class="black--text"
          >Mohon maaf, Anda tidak dapat mengubah pertanyaan karena terdapat responden yang telah mengisi kuesioner.
          Terima kasih atas pemahaman Anda.</div
        >
      </v-alert>
      <v-alert v-else text type="info">
        <div class="black--text">
          Anda ingin melihat kuesioner Anda sebelum mempublikasikannya? Silakan buka tab pratinjau untuk melihat
          hasilnya.
        </div>
      </v-alert>
    </template>
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-card v-for="(form, f) in forms" :key="f" class="mb-5">
        <v-card-text class="pa-5 black--text">
          <span class="text-h6 font-weight-regular"> {{ isPengumuman ? 'Konten ke -' : 'Pertanyaan ke -' }} {{ f + 1 }} </span>
          <div class="mt-2">
            <v-row>
              <v-col cols="12" :md="form.k_tipe_soal === 6 ? 12 : 7" sm="12">
                <span class="grey--text">{{ (form.k_tipe_soal === 6 || isPengumuman) ? 'Konten Informasi' : 'Pertanyaan' }}</span>
                <template v-if="form.k_tipe_soal === 6">
                  <div class="survey-editor-wrapper">
                    <vue-editor
                      v-model="form.label"
                      :disabled="isReadonly"
                      :editorToolbar="editorToolbar"
                      placeholder="Tuliskan konten informasi di sini..."
                    />
                  </div>
                </template>
                <template v-else>
                  <v-text-field
                    dense
                    single-line
                    outlined
                    label="Judul Kuesioner"
                    hint="Isikan judul kuesioner"
                    v-model="form.label"
                    :readonly="isReadonly"
                    :data-vv-name="`survey_${f + 1}`"
                    :data-vv-as="`Pertanyaan ke ${f + 1}`"
                    v-validate="'required'"
                    :error-messages="errors.collect(`form.${'survey_' + (f + 1)}`)"
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <span class="grey--text">Model Jawaban</span>
                <v-select
                  v-model="form.k_tipe_soal"
                  :items="filteredModels"
                  dense
                  outlined
                  placeholder="Pilih Model"
                  item-value="value"
                  item-text="label"
                  :readonly="isReadonly || isPengumuman"
                  :disabled="isReadonly || isPengumuman"
                  :data-vv-name="`opsi_${f + 1}`"
                  :data-vv-as="`Pilihan ke ${f + 1}`"
                  v-validate="'required'"
                  :error-messages="errors.collect(`form.${'opsi_' + (f + 1)}`)"
                  @change="changeOpsi(f)"
                >
                  <template v-slot:item="{ item }">
                    <v-icon left>{{ item.icon }}</v-icon>
                    {{ item.label }}
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-icon left>{{ item.icon }}</v-icon>
                    {{ item.label }}
                  </template>
                </v-select>
              </v-col>
              <v-col v-if="form['k_tipe_soal']" class="py-2 my-n2" cols="12" md="12" sm="12">
                <template v-if="form.k_tipe_soal === 6">
                  <v-alert text type="info" class="mb-0">
                    <div class="black--text">
                      <strong>Tidak Membutuhkan Jawaban</strong> — Pertanyaan ini bersifat informatif dan tidak memerlukan jawaban dari responden.
                    </div>
                  </v-alert>
                </template>
                <template v-else-if="[1, 2, 3].includes(form.k_tipe_soal)">
                  <div v-for="(option, o) in form.opsi" :key="o" class="d-flex justify-space-between">
                    <v-sheet class="">
                      <v-text-field
                        v-model="option['label']"
                        :readonly="isReadonly"
                        style="width: 400px"
                        :disabled="option.is_catatan === 1"
                        :placeholder="`opsi ${o + 1}`"
                      >
                        <template v-slot:prepend>
                          <span v-if="form.k_tipe_soal == 3" class="mt-1">{{ o + 1 }}</span>
                          <v-icon v-else>
                            {{ icons[form.k_tipe_soal] }}
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-sheet>
                    <v-sheet class="mt-4">
                      <v-btn v-if="!isReadonly" small icon color="red" @click="delOption(o, f)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-sheet>
                  </div>
                  <div v-if="!isReadonly">
                    <a @click="addOption(f)">
                      <v-icon left>mdi-plus</v-icon>
                      Tambah Opsi
                    </a>
                    <span v-if="!getDeepObj(form, 'is_catatan') && ![4, 5].includes(form.k_tipe_soal)">
                      atau isian "<a @click="addLainnya(f)">Lainnya...</a> "(responden dapat mengisikan jawaban bebas)
                    </span>
                  </div>
                </template>
                <template v-else>
                  <component
                    :is="form.k_tipe_soal == 4 ? 'VTextField' : 'VTextarea'"
                    :label="form.k_tipe_soal == 4 ? 'Jawaban Singkat' : 'Jawaban Paragraf'"
                    :placeholder="
                      form.k_tipe_soal == 4
                        ? 'Teks jawaban singkat dari responden (maksimal 60 karakter)'
                        : 'Teks jawaban panjang dari responden (maksimal 180 karakter)'
                    "
                    persistent-placeholder
                    outlined
                    dense
                    disabled
                    row="3"
                  >
                  </component>
                </template>
              </v-col>
              <v-col cols="12" class="py-2" md="12" sm="12">
                <v-divider />
                <div class="d-flex flex-row-reverse">
                  <v-sheet class="pt-5">
                    <m-menu v-if="!isReadonly" style="float: right" :items="more_menu" :object="f" />
                  </v-sheet>
                  <v-sheet class="px-1">
                    <v-switch
                      v-if="form.k_tipe_soal !== 6"
                      v-model="form['is_required']"
                      label="Wajib diisi"
                      color="primary"
                      :true-value="1"
                      :false-value="0"
                      :disabled="isReadonly"
                      hide-details
                    ></v-switch>
                    <span v-else class="caption grey--text pt-6 d-inline-block">Tidak memerlukan jawaban</span>
                  </v-sheet>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
    <div v-if="!isReadonly && !isPengumuman" class="d-flex flex-row-reverse mt-5">
      <v-btn color="primary" @click="addQuestion"> <v-icon left>mdi-plus</v-icon> Pertanyaan </v-btn>
    </div>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-editor'
export default {
  components: { VueEditor },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    isReadInfo: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isPengumuman() {
      return Number(this.getDeepObj(this.info, 'k_kategori_kuesioner')) === 2
    },
    filteredModels() {
      if (!this.isPengumuman) {
        return this.models.filter((m) => m.value !== 6)
      }
      return this.models
    },
  },
  data() {
    return {
      editorToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: [1, 2, 3, false] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['link'],
        ['clean'],
      ],
      forms: [],
      more_menu: [
        {
          title: 'Duplikasi',
          icon: 'mdi-content-copy',
          icnColor: 'blue',
          click: (i, o) => this.onDuplicate(o),
        },
        {
          title: 'Hapus',
          icon: 'mdi-delete',
          icnColor: 'red',
          click: (i, o) => this.onDelete(o),
          check: () => this.forms.length !== 1,
        },
      ],
      icons: { 1: 'mdi-radiobox-blank', 2: 'mdi-checkbox-blank-outline' },
      models: [
        {
          type: 'radio',
          icon: 'mdi-radiobox-blank',
          label: 'Pilihan Ganda',
          value: 1,
        },
        {
          type: 'checkbox',
          icon: 'mdi-checkbox-marked',
          label: 'Kotak Centang',
          value: 2,
        },
        {
          type: 'select',
          icon: 'mdi-arrow-down-drop-circle-outline',
          label: 'Tarik Turun',
          value: 3,
        },
        {
          type: 'short',
          icon: 'mdi-text-short',
          label: 'Jawaban Singkat',
          value: 4,
        },
        {
          type: 'long',
          icon: 'mdi-text',
          label: 'Jawaban Paragraf',
          value: 5,
        },
        {
          type: 'info',
          icon: 'mdi-information-outline',
          label: 'Tidak Membutuhkan Jawaban',
          value: 6,
        },
      ],
    }
  },
  methods: {
    addOption(f) {
      // const length = this.forms[f]['opsi'].length || 0
      this.forms[f]['opsi'].push({
        label: ``,
      })
    },
    delOption(index, f) {
      if (this.getDeepObj(this.forms, `${f}.opsi.${index}.type`) === 'opsi') {
        this.$delete(this.forms[f], 'is_catatan')
      }
      this.forms[f]['opsi'].splice(index, 1)
    },
    addLainnya(f) {
      this.$set(this.forms[f], 'is_catatan', true)
      this.forms[f]['opsi'].push({ label: 'Lainnya...', is_catatan: 1 })
    },
    addQuestion() {
      if (this.isPengumuman) {
        this.forms.push({ opsi: [], is_required: 0, k_tipe_soal: 6 })
      } else {
        this.forms.push({ opsi: [], is_required: 1 })
      }
    },
    onDuplicate(index) {
      const item = Object.assign({}, this.forms[index] || {})
      this.forms.splice(index + 1, 0, JSON.parse(JSON.stringify(item)))
    },
    onDelete(index) {
      this.forms.splice(index, 1)
    },
    changeOpsi(index) {
      const form = this.forms[index]
      if (!form) return

      const hasHtml = /<[a-z/][\s\S]*?>/i.test(form.label || '')
      // Jika sebelumnya tipe info (6) atau (belum ter-set dan label mengandung tag HTML), bersihkan formatting HTML pada label
      const isSwitchingFromInfo = form._prevTipeSoal === 6 || (form._prevTipeSoal === undefined && hasHtml)

      if (isSwitchingFromInfo && Number(form.k_tipe_soal) !== 6) {
        if (form.label) {
          let cleanLabel = form.label
            .replace(/<\/p>/gi, ' ')
            .replace(/<br\s*\/?>/gi, ' ')
            .replace(/<\/h[1-6]>/gi, ' ')
            .replace(/<\/div>/gi, ' ')
            .replace(/<\/li>/gi, ' ')
          
          const doc = new DOMParser().parseFromString(cleanLabel, 'text/html')
          let plainText = doc.body.textContent || ''
          
          // Ganti multi-space dengan single space dan trim
          plainText = plainText.replace(/\s+/g, ' ').trim()
          
          this.$set(form, 'label', plainText)
        } else {
          this.$set(form, 'label', '')
        }
      }
      // Simpan tipe saat ini sebagai referensi sebelumnya
      this.$set(form, '_prevTipeSoal', Number(form.k_tipe_soal))

      // Tipe "Tidak Membutuhkan Jawaban" (info)
      if (Number(form.k_tipe_soal) === 6) {
        this.$set(form, 'opsi', [])
        this.$set(form, 'is_required', 0)
        return
      }

      if (
        form['k_tipe_pengisian'] &&
        Number(form['k_tipe_pengisian']) > 3
      ) {
        this.$delete(form, 'opsi')
      } else {
        if (form['opsi'] && form['opsi'].length === 0) form['opsi'] = [{ label: '' }]
      }
    },
    reset() {
      this.$validator.reset()
      this.forms = []
      if (this.forms.length === 0) {
        this.addQuestion()
      }
    },
    initForm(items) {
      this.forms = []
      if (items.length) {
        this.forms = items.map(item => {
          this.$set(item, '_prevTipeSoal', Number(item.k_tipe_soal))
          if (this.isPengumuman) {
            item.k_tipe_soal = 6
          }
          return item
        })
      }
    },
    isAllNoResponse() {
      return this.forms.length > 0 && this.forms.every((f) => Number(f.k_tipe_soal) === 6)
    },
    async getValue(isNotValidate = false) {
      if (isNotValidate) {
        return []
      }

      // Jika semua pertanyaan bertipe "Tidak Membutuhkan Jawaban", skip validasi
      const allNoResponse = this.isAllNoResponse()
      if (!allNoResponse) {
        const validator = await this.$validator.validateAll('form')
        if (!validator) {
          return false
        }
      }

      let items = JSON.parse(JSON.stringify(this.forms || [])) || []
      if (items.length > 0) {
        items.map((item, i) => {
          if ([4, 5, 6].includes(Number(item.k_tipe_soal))) {
            delete item.opsi
          }
          // Tipe info: pastikan is_required = 0
          if (Number(item.k_tipe_soal) === 6) {
            item.is_required = 0
          }
          if (item.opsi && typeof item.opsi === 'object' && item.opsi.length > 0) {
            item.opsi.map((op, i) => {
              op.urutan = i + 1
              return op
            })
          }
          item.urutan = i + 1
          // Hapus properti internal yang tidak perlu dikirim ke backend
          delete item._prevTipeSoal
          return item
        })
      }
      return items || []
    },
  },
  watch: {
    forms: {
      handler(item) {
        this.$emit('surveys', item)
        this.$emit('allNoResponse', this.isAllNoResponse())
      },
      deep: true,
      immediate: true,
    },
    isPengumuman: {
      handler(val) {
        if (val) {
          this.forms.forEach((form, index) => {
            this.$set(form, 'k_tipe_soal', 6)
            this.changeOpsi(index)
          })
        } else {
          this.forms.forEach((form, index) => {
            if (Number(form.k_tipe_soal) === 6) {
              this.$set(form, 'k_tipe_soal', 1)
              this.changeOpsi(index)
            }
          })
        }
      },
      immediate: true,
    },
  },
}
</script>
<style scoped>
.survey-editor-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 4px;
}
.survey-editor-wrapper:hover {
  border-color: rgba(0, 0, 0, 0.87);
}
</style>
<style>
.survey-editor-wrapper .ql-toolbar {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  background: #fafafa;
}
.survey-editor-wrapper .ql-container {
  border: none !important;
  min-height: 150px;
  font-size: 14px;
}
.survey-editor-wrapper .ql-editor {
  min-height: 150px;
}
</style>
